import { BlogPost, BlogCategory } from '../types/blog';
import { blogPosts } from '../data/blogPosts';

const featuredBlogSlug = 'building-my-own-vidiq';

const getPublishedPosts = (): BlogPost[] =>
  blogPosts
    .filter(post => post.published)
    .sort((a, b) => {
      const publishedDiff =
        new Date(b.published_at).getTime() - new Date(a.published_at).getTime();
      if (publishedDiff !== 0) return publishedDiff;
      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    });

export const blogService = {
  async getFeaturedPost(): Promise<BlogPost | null> {
    const publishedPosts = getPublishedPosts();
    return (
      publishedPosts.find(post => post.slug === featuredBlogSlug) ||
      publishedPosts.find(post => post.featured) ||
      publishedPosts[0] ||
      null
    );
  },

  async getPosts({
    category,
    page = 1,
    limit = 6,
    searchQuery = '',
  }: {
    category?: string;
    page?: number;
    limit?: number;
    searchQuery?: string;
  }): Promise<{ posts: BlogPost[]; total: number }> {
    const normalizedSearch = searchQuery.trim().toLowerCase();
    let filteredPosts = getPublishedPosts();

    if (category && category !== 'All') {
      filteredPosts = filteredPosts.filter(post => post.category === category);
    }

    if (normalizedSearch) {
      filteredPosts = filteredPosts.filter(post =>
        `${post.title} ${post.content}`.toLowerCase().includes(normalizedSearch)
      );
    }

    const from = (page - 1) * limit;
    const to = from + limit;

    return {
      posts: filteredPosts.slice(from, to),
      total: filteredPosts.length,
    };
  },

  async getCategories(): Promise<BlogCategory[]> {
    return Array.from(new Set(getPublishedPosts().map(post => post.category)))
      .sort((a, b) => a.localeCompare(b))
      .map(category => ({
        id: category,
        name: category,
        slug: category.toLowerCase().replace(/\s+/g, '-')
      }));
  },

  async getPostBySlug(slug: string): Promise<BlogPost | null> {
    return getPublishedPosts().find(post => post.slug === slug) || null;
  }
};
